export const sendMessageToParent = ({ type, message }) => {
  const targetMessage = '*';
  window.parent.postMessage({ type, message }, targetMessage);
}



// WEBPACK FOOTER //
// ./src/helpers/messageProxy.js